/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Input as AntdInput, InputNumber as AntdInputNumber } from 'antd';
import clsx from 'clsx';

import s from './styles.module.less';

const Input = React.forwardRef(({ className, ...props }, ref) => (
  <AntdInput ref={ref} className={clsx(s.custom, className)} {...props} />
));

const Search = ({ className, ...props }) => <AntdInput.Search className={clsx(s.custom, className)} {...props} />;

const TextArea = ({ className, ...props }) => <AntdInput.TextArea className={clsx(s.custom, className)} {...props} />;

const Password = ({ className, ...props }) => <AntdInput.Password className={clsx(s.custom, className)} {...props} />;

const Number = ({ className, ...props }) => <AntdInputNumber className={clsx(s.custom, className)} {...props} />;

Input.Group = AntdInput.Group;
Input.Search = Search;
Input.TextArea = TextArea;
Input.Password = Password;
Input.Number = Number;
export default Input;
